import { mapGetters } from 'vuex';
import mvtSeoLink from '@/common/components/mvtseolink/mvt-seolink.vue';

export default {
    name: 'propertySeoLink',
    components: {
        mvtSeoLink,
    },
    props: {
        showSiteMapLinks: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp']),
        getMapSearchLinks() {
            let filterMapper1 = {
                singleFamily: { url: 'single-family' },
                condo: { url: 'condos' },
                land: { url: 'land' },
                multiFamily: { url: 'multi-family' },
                mobile: { url: 'mobile' },
                newConstruction: { url: 'new-construction' },
            };
            let filterMapper2 = {
                rentals: { url: 'rentals' },
                apartmentsRent: { url: 'rentals/condos' },
                singleFamilyRent: { url: 'rentals/single-family' },
                sold: { url: 'sold' },
            };
            let filterMapper = this.showSeoLinks ? { ...filterMapper1, ...filterMapper2, ...{ waterfront: { url: 'att-waterfront' }, foreclosed: { url: 'foreclosed' } } } : filterMapper2;

            let mapSearchLinksObj = this.generateMapSearchUrl(this.glb.appUrl, {
                type: 'city',
                cityName: this.dpp.geo.city,
                stateCode: this.dpp.geo.stateCode,
                listingCountObj: this.glb.listingCountObj,
                rentals: false,
            });
            mapSearchLinksObj.filterArray = Object.keys(filterMapper);
            mapSearchLinksObj.filterMapper = filterMapper;
            return mapSearchLinksObj;
        },
        cities() {
            if (this.showSiteMapLinks) {
                return this.dpp.seoNearbyCity.slice(0, 10);
            }
            return this.dpp.seoNearbyCity;
        },
        zipcodes() {
            if (this.showSiteMapLinks) {
                return this.dpp.seoNearbyZipCode.slice(0, 10);
            }
            return this.dpp.seoNearbyZipCode;
        },
        neighborhoods() {
            if (this.showSiteMapLinks) {
                return this.dpp.seoNearbyNeighborhood.slice(0, 10);
            }
            return this.dpp.seoNearbyNeighborhood;
        },
        counties() {
            if (this.showSiteMapLinks) {
                return this.dpp.seoNearbyCounty.slice(0, 10);
            }
            return this.dpp.seoNearbyCounty;
        },
        showSeoLinks() {
            return this.glb.listingCountObj['city'] && this.glb.listingCountObj['city'].homeForSaleCount >= 10;
        },
    },
};
